import { render, staticRenderFns } from "./TableRowEditForm.vue?vue&type=template&id=4b53f72a"
import script from "./TableRowEditForm.vue?vue&type=script&lang=js"
export * from "./TableRowEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports